import { BaseException, BaseExceptionContext } from './base.exception';

interface UnexpectedExceptionContext extends BaseExceptionContext {}

export class UnexpectedException extends BaseException {
  constructor(context: UnexpectedExceptionContext) {
    super(`Unexpected exception`, context);
  }
}
